import { getAuth } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { logOut, url } from "../config/constant";
import { Logout } from "iconsax-react";

export default function UserCard() {
  const [userDetails, setUserDetails] = useState();
  useEffect(() => {
    async function checkLogin() {
      await getAuth().onAuthStateChanged(async (user) => {
        if (!user) return (window.location = "/");
        if (user) {
          await fetch(`${url}/user/${user.phoneNumber}`).then(async (res) => {
            const body = await res.json();
            if (res.status !== 200 || body === null || body === undefined) {
              await logOut();
              return;
            }

            setUserDetails(body);
          });
        }
      });
    }
    checkLogin();
  }, []);
  if (!userDetails) return <></>;
  return (
    <div className="flex items-center gap-x-5 bg-white rounded-3xl p-5">
      <div className="w-20 h-20">
        <img
          className="w-20 absolute h-20 object-cover rounded-full overflow-hidden"
          src={userDetails.image}
          alt={userDetails.name}
        />
      </div>

      <div className=" flex w-full items-center gap-x-2 justify-between">
        <div className="pl-2">
          <b>Name : </b>
          {userDetails.name}
          <br />

          {userDetails.mobile}
          <br />
          <b>Gender : </b>
          {userDetails.gender}
        </div>
        <div
          onClick={() => {
            var logoutConfirm = window.confirm(
              "Do you really want to logout ?"
            );
            if (logoutConfirm) {
              logOut();
            }
          }}
        >
          <Logout className="text-primary hover:text-red" />
        </div>
      </div>
    </div>
  );
}
